// @flow

type Urls =
  | 'flags'
  | 'gates'
  | 'github'
  | 'github_edit'
  | 'team'
  | 'site'
  | 'vscode';

export const createStripeInternalUrl = (
  id: Urls,
  data?: {[key: string]: string},
) => {
  const URLS = {
    flags: 'https://go/flag/%flag%',
    gates: 'https://go/gate/%gate%',
    github: 'http://go/ps/blame/master/%root%%filename%',
    github_edit: 'http://go/ps/edit/master/%root%%filename%',
    team: 'https://go/ldap/groups/codeowners-%owner%',
    site: 'https://go/site-admin/docs/%path%',
    vscode: 'https://go/vs/%root%%filename%',
  };

  const url = URLS[id] || '';

  return data
    ? url.replace(/%\w+%/g, (match) => {
        return data[match.replace(/%/g, '')] || '';
      })
    : url;
};
